import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import createAuth0Client, { GetTokenSilentlyOptions } from '@auth0/auth0-spa-js';
import Auth0Client from '@auth0/auth0-spa-js/dist/typings/Auth0Client';
import { tap, catchError, concatMap, shareReplay, delay } from 'rxjs/operators';
import { from, of, Observable, BehaviorSubject, combineLatest, throwError } from 'rxjs';
import { AuthConfig, UserStateModel } from '../../../model';
import { ConfigState, SetUser } from '../../state';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  private readonly userProfileSubject$ = new BehaviorSubject<any>(null);

  authConfig: AuthConfig;
  auth0Client$: Observable<Auth0Client>;
  isAuthenticated$: Observable<boolean>;
  handleRedirectCallback$: Observable<any>;
  loggedIn: boolean = null;

  constructor() {
    // this.authConfig = this.store.selectSnapshot<AuthConfig>(ConfigState.authConfigs);
    // this.auth0Client$ = from(createAuth0Client(this.authConfig)).pipe(
    //   shareReplay(1),
    //   catchError(err => throwError(() => err))
    // );
    //
    // this.isAuthenticated$ = this.auth0Client$.pipe(
    //   concatMap((client: Auth0Client) => from(client.isAuthenticated())),
    //   tap(res => (this.loggedIn = res))
    // );
    // this.handleRedirectCallback$ = this.auth0Client$.pipe(concatMap((client: Auth0Client) => from(client.handleRedirectCallback())));
    // this.localAuthSetup();
    // this.handleAuthCallback();
  }

  // getUser$(options?): Observable<UserStateModel> {
  //   // return this.auth0Client$.pipe(
  //   //   concatMap((client: Auth0Client) => from(client.getUser(options))),
  //   //   tap((user: UserStateModel) => {
  //   //     this.store.dispatch(new SetUser(user));
  //   //     this.userProfileSubject$.next(user);
  //   //     return user;
  //   //   })
  //   // );
  //
  //   return of(null);
  // }
  //
  // getTokenSilently$(options?: GetTokenSilentlyOptions): Observable<string> {
  //   return this.auth0Client$.pipe(
  //     delay(500), // On initial load, it takes some time for the token to be set
  //     concatMap((client: Auth0Client) => {
  //       return from(client.getTokenSilently(options));
  //     })
  //   );
  // }
  //
  // private localAuthSetup(): void {
  //   const checkAuth$ = this.isAuthenticated$.pipe(
  //     concatMap((loggedIn: boolean) => {
  //       if (loggedIn) {
  //         return this.getUser$();
  //       }
  //       return of(loggedIn);
  //     })
  //   );
  //   checkAuth$.subscribe();
  // }
  //
  // login(redirectPath: string = '/'): void {
  //   // this.auth0Client$.subscribe({
  //   //   next: (client: Auth0Client) => {
  //   //     client.loginWithRedirect({
  //   //       redirect_uri: window.location.origin,
  //   //       appState: { target: redirectPath },
  //   //     });
  //   //   },
  //   // });
  // }
  //
  // handleAuthCallback(): void {
  //   const params = window.location.search;
  //   if (params.includes('code=') && params.includes('state=')) {
  //     let targetRoute: string;
  //     const authComplete$ = this.handleRedirectCallback$.pipe(
  //       tap(cbRes => {
  //         targetRoute = cbRes.appState && cbRes.appState.target ? cbRes.appState.target : '/';
  //       }),
  //       concatMap(() => {
  //         return combineLatest([this.getUser$(), this.isAuthenticated$]);
  //       })
  //     );
  //     authComplete$.subscribe({
  //       next: () => {
  //         this.router.navigate([targetRoute]);
  //       },
  //     });
  //   }
  // }
  //
  // logout(): void {
  //   // this.auth0Client$.subscribe({
  //   //   next: (client: Auth0Client) => {
  //   //     client.logout({
  //   //       client_id: this.authConfig.client_id,
  //   //       returnTo: window.location.origin,
  //   //     });
  //   //   },
  //   // });
  // }
}
